import { jsx } from '@emotion/react';
import { Alert, Link } from '@zapier/design-system';
import { useState, useEffect } from 'react';
import { UserInteractionEvent } from '../../../../universal-nav/utils/avroEvents';
import { useUniversalNavContext } from '../../../../universal-nav/hooks';
const ANNUAL_UPDATE_DISMISSED_KEY = 'annualUpsellDismissedOn';
const calculateAnnualSavingsAmount = (data) => {
    var _a;
    const { currentAccount } = data;
    const currentPlan = currentAccount.plan;
    const alternatePlan = (_a = data.possiblePlans
        .find((possiblePlan) => {
        return possiblePlan.planType === currentPlan.type;
    })) === null || _a === void 0 ? void 0 : _a.plans.find((plan) => {
        return plan.name === currentPlan.name && plan.interval === 'year';
    });
    const currentMonthlyAmount = currentPlan.amount || 0;
    const alternateMonthlyAmount = ((alternatePlan === null || alternatePlan === void 0 ? void 0 : alternatePlan.amount) || currentMonthlyAmount) / 12;
    const difference = currentMonthlyAmount - alternateMonthlyAmount;
    const savingsAmount = difference / currentMonthlyAmount;
    return {
        savingsAmount,
        alternatePlan,
    };
};
export const shouldRender = (data) => {
    const { currentAccount: { plan }, } = data;
    const isEligibleForAnnualUpsell = plan.interval !== 'year' && plan.isInPlanGroup;
    const hasDismissedAnnualUpsell = localStorage.getItem(ANNUAL_UPDATE_DISMISSED_KEY) !== null;
    if (hasDismissedAnnualUpsell || !isEligibleForAnnualUpsell) {
        return false;
    }
    return calculateAnnualSavingsAmount(data).savingsAmount > 0;
};
export const Component = function AnnualBillingUpsell(props) {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const [annualUpsellDismissedOn, setAnnualUpsellDismissedOn] = useState(localStorage.getItem(ANNUAL_UPDATE_DISMISSED_KEY));
    useEffect(() => {
        if (annualUpsellDismissedOn !== null) {
            try {
                localStorage.setItem(ANNUAL_UPDATE_DISMISSED_KEY, annualUpsellDismissedOn);
            }
            catch (_a) {
                console.log('Failed to save annualUpsellDismissedOn to localStorage');
            }
        }
    }, [annualUpsellDismissedOn]);
    const { data } = props;
    const { savingsAmount, alternatePlan } = calculateAnnualSavingsAmount(data);
    const savingsPercent = `${Math.floor(savingsAmount * 100)}%`;
    const upgradeUrl = encodeURI((alternatePlan === null || alternatePlan === void 0 ? void 0 : alternatePlan.id)
        ? `/app/planbuilder/checkout?planId=${alternatePlan === null || alternatePlan === void 0 ? void 0 : alternatePlan.id}`
        : '/app/planbuilder/plans');
    const onUpgrade = () => {
        props.trackEvent(UserInteractionEvent, {
            interaction_name: 'annual_billing_upsell_banner_cta_clicked',
            event_action: 'click',
            interaction_goal: 'upgrade_plan',
            option_selected: 'not_applicable',
        });
    };
    const onDismiss = () => {
        setAnnualUpsellDismissedOn(new Date().toUTCString());
    };
    const title = (jsx("span", null,
        `Save ${savingsPercent} when you `,
        jsx(Link, { href: getFullyQualifiedURL(upgradeUrl), onClick: onUpgrade }, "switch to an annual subscription")));
    if (annualUpsellDismissedOn) {
        return null;
    }
    return (jsx(Alert, { variant: props.variant, title: title, status: "info", onDismiss: onDismiss }));
};
//# sourceMappingURL=AnnualBillingUpsell.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
